import { BasePlugin } from './../base-plugin.component';
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PluginComponent } from '../plugin.component';
import { Inspection } from '../../shared/models/index';

@Component({
    templateUrl: './filemanager.component.html',
    standalone: false
})
export class FileManagerPluginComponent extends BasePlugin implements OnInit {
  public plugin: any = {};
  inspectionId: string;
  public inspection: Inspection;

  constructor(private route: ActivatedRoute, private cdRef: ChangeDetectorRef) {
    super();
  }

  config(
    plugin: any,
    inspection: Inspection,
    messages: Array<string>,
    showBreadcrumbs: boolean,
    showValidations: boolean,
    showContent: boolean
  ): void {
    super.config(plugin, inspection, messages, showBreadcrumbs, showValidations, showContent);
    this.initData();
    this.cdRef.detectChanges();
  }

  initData() {}

  ngOnInit(): void {}

  getEditRoute() {
    return [
      this.inspection.isTemplate() ? this.templatesRoute : this.inspectionsRoute,
      this.inspection.id,
      'points',
      this.plugin.pointId ? this.plugin.pointId : -1,
      'plugins',
      this.plugin.id,
      'filemanager',
      'edit'
    ];
  }
}

PluginComponent.plugins['filemanager'] = FileManagerPluginComponent;
